<div class="carousel d-flex">
  @if (slide.image_url && slide.image_url.indexOf('coming_soon') < 0) {
    <div
      class="carousel-image col-md-6"
      >
      @if (!isVideo) {
        <img class="w-100" [src]="slide.image_url" />
      }
      @if (slide && isVideo) {
        <app-slideshow-media-embed
          [slide]="slide"
        ></app-slideshow-media-embed>
      }
    </div>
  }
  <div>
    <app-slide-content [slide]="slide"></app-slide-content>
  </div>
</div>
